import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-隐藏",
  "use": "icon-隐藏-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-隐藏\">\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19 3.5H1V2.5H19V3.5Z\" />\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19 9.92871H1V8.92871H19V9.92871Z\" />\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19 16.5H1V15.5H19V16.5Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol